/**
 * Width of the navigation rail, in px.
 *
 * The rail is sized by its widest tab rather than by an explicit width, so this
 * is the tab min-width AND the cap on the tooltip labels that sit under each
 * icon. Both have to come from the same number: the labels are rendered in a
 * popper, which is positioned outside the rail's own layout and will happily
 * paint over the pane next to it. "Management" did exactly that.
 */
export const NAV_RAIL_WIDTH = 90;
